import { render, staticRenderFns } from "./ImsTerm.vue?vue&type=template&id=568b00f9&scoped=true"
import script from "./ImsTerm.vue?vue&type=script&lang=js"
export * from "./ImsTerm.vue?vue&type=script&lang=js"
import style0 from "./ImsTerm.vue?vue&type=style&index=0&id=568b00f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568b00f9",
  null
  
)

export default component.exports